import and from './and'
import not from './not'
import or from './or'
import pathnameIncludesAfterKey from './pathnameIncludesAfterKey'
import pathnameIncludesOne from './pathnameIncludesOne'
import referrerExists from './referrerExists'
import referrerIncludesPlatform from './referrerIncludesPlatform'
import referrerIsSameAsSite from './referrerIsSameAsSite'
import searchParamEqualsOne from './searchParamEqualsOne'
import searchParamsIncludeOne from './searchParamsIncludeOne'
import searchParamIncludesOne from './searchParamIncludesOne'

export default {
  and,
  not,
  or,
  pathnameIncludesAfterKey,
  pathnameIncludesOne,
  referrerExists,
  referrerIncludesPlatform,
  referrerIsSameAsSite,
  searchParamEqualsOne,
  searchParamsIncludeOne,
  searchParamIncludesOne,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/index.js